export default __webpack_public_path__ + "static/media/Resume.b07671eb.pdf";